//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  block: 'logo',
  props: ['logo'],
  computed: {
    logoURL() {
      // if (this.sections[this.currentSection] == null)
      //   return this.offWhiteLogoURL;

      // return (!this.sections[this.currentSection].whiteLogo) ? this.offBlackLogoURL : this.offWhiteLogoURL;

      return this.sandLogoURL;
    }
  },
  data() {
    return {
      blueLogoURL: require("@/assets/imgs/logo/Spotin_TM_Logo_Blue_Small_RGB.png"),
      offBlackLogoURL: require("@/assets/imgs/logo/Spotin_TM_Logo_Off-Black_Small_RGB.png"),
      offWhiteLogoURL: require("@/assets/imgs/logo/Spotin_TM_Logo_Off-White_Small_RGB.png"),
      sandLogoURL: require("@/assets/imgs/logo/Spotin_TM_Logo_Sand_Small_RGB.png"),    
      alt: 'Spotin Logo'
    }
  },
};



// WEBPACK FOOTER //
// ./components/templates/Logo.vue